import * as t from 'io-ts';
import { ImageDynamicType } from './image';

export const GiftDynamicType = t.interface({
    id: t.string,
    categoryId: t.string,
    name: t.string,
    description: t.string,
    longDescription: t.string,
    price: t.number,
    image: t.union([ImageDynamicType, t.null]),
});

export type Gift = t.TypeOf<typeof GiftDynamicType>;
